import gql from 'graphql-tag';

export const CREATE_TIP_BY_CATEGORY = gql`
  mutation CreateTipsCategory($input: CreateTipsCategoryInput!) {
    createTipsCategory(input: $input) {
      _id
    }
  }
`;

export const CREATE_TIP = gql`
  mutation CreateTip($input: CreateTipsInput!) {
    createTip(input: $input) {
      _id
    }
  }
`;

export const UPDATE_TIP = gql`
  mutation UpdateTip($id: MOID!, $input: UpdateTipsInput!) {
    updateTip(id: $id, input: $input)
  }
`;

export const REMOVE_TIP = gql`
  mutation RemoveTip($id: MOID!) {
    removeTip(id: $id)
  }
`;
